// extracted by mini-css-extract-plugin
export default {"container":"FooterCopyright_container__UhUf9","copyright":"FooterCopyright_copyright__yweRi","yandex_project_logo":"FooterCopyright_yandex_project_logo__-Qa-O"};